import styled from 'styled-components';

const StyledHeadContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledHeadRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledHeadingContainer = styled.div<{ $hidden?: boolean }>`
	display: ${(props) => (props.$hidden ? 'none' : 'flex')};
	align-items: center;
	gap: 10px;

	& > img {
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledHeadContainer,
	StyledHeadingContainer,
	StyledHeadRightContainer,
};
